module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a10_illustration"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('p', {
    staticClass: "illu"
  }, [_vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("(The rank and title at the time of Jutland are the ones given)")])]), _c('p', {
    staticClass: "illu2"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/01_uthor#uthf1"
    }
  }, [_vm._v("Admiral Sir John Jellicoe, Commander-in-Chief, Grand")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2a"
  }, [_vm._v("Fleet, 1914–16 (a post-war photograph)      "), _c('i', [_vm._v("Frontispiece")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("("), _c('i', [_vm._v("Photograph: Radio Times Hulton Picture Library")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "illu2b"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#plaf1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I.   Vice-Admiral Sir David Beatty, Commanding Battle Cruiser Fleet, 1914–16, with H.M. King George V (on the quarter deck of the "), _c('i', [_vm._v("Queen Elizabeth")]), _vm._v(", 1917)")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(Photograph: by permission of the second Earl Beatty)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu2b"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#plaf2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II.   1. Vice-Admiral Sir Cecil Burney, Second-in-Command, Grand Fleet, Commanding 1st Battle Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("("), _c('i', [_vm._v("From the portrait-drawing by Francis Dodd, by permission of the Trustees of the Imperial War Museum)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu3"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#plaf3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Vice-Admiral Sir Martyn Jerram, Commanding 2nd Battle Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(Photograph: by permission of the Trustees of the National Portrait Gallery)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu2b"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#plaf4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III.   1. Vice-Admiral Sir Doveton Sturdee, Commanding 4th Battle Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("("), _c('i', [_vm._v("From the portrait-sketch by Sir Arthur Cope, by permission of the Trustees of the National Maritime Museum)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu3"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#plaf5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Rear-Admiral Hugh Evan-Thomas, Commanding 5th Battle Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("(From the portrait-drawing by Francis Dodd, by permission of the Trustees of the Imperial War Museum)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu2b"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#plaf6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV.   1. Rear-Admiral the Hon. Horace L. A. Hood, Commanding 3rd Battle Cruiser Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu3"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#plaf7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Rear-Admiral William C. Pakenham, Commanding 2nd Battle Cruiser Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(Photographs: by permission of the second Earl Beatty)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu2b"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#plaf8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V.   1. Commodore William E. Goodenough, Commanding 2nd Light Cruiser Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(From the portrait-drawing by Francis Dodd, by permission of the Trustees of the Imperial War Museum)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu3"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#plaf9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Commodore Edwyn S. Alexander-Sinclair, Commanding 1st Light Cruiser Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(From the portrait-drawing by Francis Dodd, by permission of the Trustees of the Imperial War Museum)")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('p', {
    staticClass: "illu2b"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/16_ch3#plaf10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI.   1. H.M.S. "), _c('i', [_vm._v("Lion")]), _vm._v(" being hit on QTurret, 31 May")])]), _vm._v(" "), _c('p', {
    staticClass: "illu3"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#plaf11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The wreck of H.M.S. "), _c('i', [_vm._v("Invincible")]), _vm._v(", about half an hour after the destruction of the ship")])]), _vm._v(" "), _c('p', {
    staticClass: "illu4"
  }, [_vm._v("(The destroyer "), _c('i', [_vm._v("Badger")]), _vm._v(" is approaching to pick up the six survivors, four of whom, including Cdr. H. E. Dannreuther, are on the raft just visible between the wreck and the destroyer.)")]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(Photographs: by permission of the Trustees of the Imperial War Museum)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu2b"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#plaf12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII.   1. Vice-Admiral Reinhard Scheer, Commanding the High Seas Fleet, 1916–18")])]), _vm._v(" "), _c('p', {
    staticClass: "illu3"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#plaf13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  2. Vice-Admiral Franz Hipper, Commanding the Scouting Forces, 1913–18")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("("), _c('i', [_vm._v("Photographs: by permission of the Trustees of the Imperial War Museum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2b"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#plaf14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII.   1. H.M.S. "), _c('i', [_vm._v("Iron Duke")]), _vm._v(", flagship of the Grand Fleet")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(Photograph: Richard Perkins)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu3"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#plaf15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  2. H.M.S. "), _c('i', [_vm._v("Lion")]), _vm._v(", flagship of the Battle Cruiser Fleet")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2c"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("(Photograph: by permission of the second Earl Beatty)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu6"
  }, [_c('i', [_vm._v("Plates I, IV."), _c('span', {
    staticClass: "small"
  }, [_vm._v("I")]), _vm._v(", IV."), _c('span', {
    staticClass: "small"
  }, [_vm._v("2")]), _vm._v(", and VIII."), _c('span', {
    staticClass: "small"
  }, [_vm._v("2")]), _vm._v(" are reproduced, by the kindness of the second Earl Beatty, from the album of photographs of ships and officers of the Battle Cruiser Fleet presented to his father by those under his command.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72beb969","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/10_illustration.vue
// module id = 84
// module chunks = 0